
const LOCAL_STORAGE_ROTATE_KEY = 'dokka_documents_rotation';

export function getRotateFromStore() {
  const str = window.localStorage.getItem(LOCAL_STORAGE_ROTATE_KEY) || '{}';
  return JSON.parse(str);
}

export function getRotateByDocID(documentID) {
  const data = getRotateFromStore();
  if (data && documentID in data) return data[documentID];
  return null;
}

export function setRotateByDocID(documentID, params) {
  const store = getRotateFromStore();
  let newStore = {
    ...store,
  };
  if (store && documentID in store) {
    newStore = {
      ...newStore,
      [documentID]: { ...store[documentID], ...params },
    };
  } else {
    newStore = { ...newStore, [documentID]: params };
  }
  const value = JSON.stringify(newStore);
  window.localStorage.setItem(LOCAL_STORAGE_ROTATE_KEY, value);
}
